import { requestTypes } from "../requestRoutes";
import { SelectDropdown } from "../../types";

export const requestTypeSelect: SelectDropdown = {
	selectName: 'type',
	defaultValue: 'all',
	minWidth: 130,
	selectMenu: [{ value: 'all', label: 'כל הקריאות' }, ...requestTypes]
};